import * as d3 from 'd3';
import Svg, { Path } from 'react-native-svg';
import { useEffect, useRef } from 'react';
import moment from 'moment-timezone';
import { BarChartMargin } from '../barChart/type';
import { useStore } from 'store/store';

interface AxisXProps {
  xScale: d3.ScaleBand<string>;
  labels: Array<string>;
  width: number;
  height: number;
  margin: BarChartMargin;
  xTitle?: string;
}

export const AxisX: React.FC<AxisXProps> = ({ xScale, labels, width, height, margin, xTitle }) => {
  const ref = useRef<SVGGElement>(null);
  const transform = `translate(${margin.left * 2}, -${0})`;

  const store = useStore();
  const textColor = store.theme === 'light' ? '#000000' : '#FFFFFF';
  const lineColor = store.theme === 'light' ? '#DCDCDC' : '#4A4A4A';

  useEffect(() => {
    // Create axis X
    const axisX = d3.axisBottom(xScale);
    axisX.tickSize(0);
    d3.select(ref.current).call(axisX as any);
    d3.select(ref.current)
      .selectAll('text')
      .attr('font-size', '13px')
      .attr('font-family', 'Poppins_400Regular')
      .attr('y', 16)
      .attr('fill', textColor);

    // Axis X line #D8D8D8
    d3.select(ref.current).select('path').attr('stroke', lineColor);

    // Add Axis X label, if label length > 10, show only every 3rd label
    if (xTitle) {
      d3.select(ref.current)
        .append('text')
        .attr('transform', `translate(${width / 2 - margin.left}, ${margin.bottom * 2})`)
        .style('text-anchor', 'middle')
        .attr('font-size', '13px')
        .attr('font-family', 'Poppins_400Regular')
        .attr('fill', '#666')
        .text(xTitle);
    }

    const labelLength = labels.length;
    const every = 1;
    const label = d3.select(ref.current).selectAll('text');
    label.each(function (d, i) {
      if (i % every !== 0) {
        d3.select(this).remove();
      }
    });

    return () => {
      d3.select(ref.current).selectAll('*').remove();
    };
  }, [width, xScale, labels]);

  return <g ref={ref} transform={transform} />;
};
